module.exports = __webpack_public_path__ + "img/Ma.Maritime.Revetments.Rockrevetment-18m.Rock.7e55b878.png";